<div class="flex-row column full">
  <div class="flex-row column full row-gap-20 p-20">
    <div class="flex-row align-center column-gap-10">
      <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close(false)">
        <img class="cursor-pointer" src="assets/new-assets/icons/icon-arrow-back.svg" alt="Go back"></button>
      <p class="text-dark fs-20 fw-8 fs-md-16">For direct purchases</p>
    </div>
    <span class="color-secondary fs-md-14">Update equity or mutual funds you have purchased directly through your
      broker. These will not be considered for rebalancing Investpacks </span>
    <div
      class="border-color-ECF3F5 border-radius-8 flex-row align-center bg-secondary pt-10 pb-10 pl-15 pr-15 column-gap-10">
      <img src="assets/new-assets/icons/icon-search-grey.svg" alt="Search" />
      <app-search-controle class="full" [class]="'fs-14 bg-none border-none text-dark'" [isAutoComplete]="true"
        [autoRef]="searchScripDP" placeholder="Search equity or mutual funds"
        (search)="onSearch($event)"></app-search-controle>
      <mat-autocomplete #searchScripDP="matAutocomplete" (optionSelected)="onTopScriptSelection($event)"
        [displayWith]="topdisplayFn">
        <mat-option *ngIf="isLoading" class="">
          <app-loader [size]="30"></app-loader>
        </mat-option>
        <mat-option *ngFor="let user of allScripsList;let i = index" [value]="user">
          <ng-container *ngIf="!user.amcCode">
            <span>{{ user.tradingSymbol }}</span>
            <small> | {{ user.exchange }}</small>
          </ng-container>
          <ng-container *ngIf="user.amcCode">
            <span>{{ user.schemeName }}</span>
          </ng-container>
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <ng-container *ngIf="selectedScrips.length">
    <ng-template [ngTemplateOutlet]="allScrips"></ng-template>
  </ng-container>
  <div class="flex-row align-center content-center column-gap-30 p-15 border-top-1 bg-white">
    <button type="button" class="btn color-blue border-color-DCEBEF text-uppercase fw-7 width-16"
      (click)="close(false)">Cancel</button>
    <button type="button" class="btn btn-primary text-uppercase fw-7 width-16">update</button>
  </div>
</div>


<ng-template #allScrips>
  <div
    class="flex-row align-center content-between full column-gap-10 row-gap-20 bg-color-F7F8F7 pt-10 pb-10 pr-20 pl-20 color-secondary fw-6 fs-14 d-none-md">
    <div class="width-25-pr">SCRIP</div>
    <div class="flex-row align-center content-between width-55-pr">
      <div class="width-25-pr text-center">Old QTY</div>
      <div class="width-25-pr text-center">New QTY</div>
      <div class="width-40-pr text-center">Price per share</div>
    </div>
    <div class="width-15-pr text-center"></div>
  </div>
  <form class="flex-row column full row-gap-20 p-20 max-height-6-vh overflow-y" [formGroup]="directPurchaseForm">
    <ng-container formArrayName="instruments" *ngFor="let stocks of getControlsArr().controls; let i = index">
      <div
        class="flex-row align-center content-between full row-gap-20 column-gap-10 column-md pb-15 border-bottom-color-ECF3F5"
        [formGroupName]="i">
        <div class="flex-row align-center width-25-pr full-md content-between column-gap-md-20">
          <div class="flex-row align-center column-gap-10">
            <div class="img rectangle flex-row">
              <!-- <img class="margin-auto" *ngIf="stocks?.insdivument?.logo" src="{{stockBaseUrl}}{{stocks?.insdivument?.logo}}"alt=""> -->
            </div>
            <p class="fs-14 fw-6 text-dark">{{stocks.controls['name'].value}}</p>
          </div>
          <div class="flex-row align-center column-gap-20 d-none d-flex-md">
            <p class="text-success text-center fs-14 fw-7 ">{{stocks.controls['scriptType'].value}}</p>
            <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt="Remove">
          </div>
        </div>
        <div class="flex-row align-center content-between width-55-pr full-md">
          <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Previous Qty.</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="oldQuantity" type="number">
          </div>
          <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Current Qty.</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="newQuantity" type="number">
          </div>
          <div class="width-40-pr width-md-30-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Price per unit</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="purchasePrice" type="number">
          </div>
        </div>
        <div class="width-15-pr flex-row align-center column-gap-15 content-between d-none-md">
          <div class="p-10 border-1 width-70-pr border-radius-4">
            <p class="text-success text-center fs-14 fw-7">{{stocks.controls['scriptType'].value}}</p>
          </div>
          <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="removeScrip(i)">
            <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt="Remove">
          </button>
        </div>
      </div>
    </ng-container>
  </form>
</ng-template>